import { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ClientModel from '../../../core/api/clients/ClientModel';
import Pagination from '../../../core/api/PageRequest';
import { parsePagination } from '../../../core/PaginationUtils';
import {parseFilter} from "../../../hooks/utils/filterUtils";

export const useClientList = () => {
  const location = useLocation();
  const [clients, setClients] = useState<ClientModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>(
    parsePagination(location.search)
  );

  const fetchClients = useCallback(async () => {
    setIsLoading(true);
    try {
      const pagination = parsePagination(location.search);
      setPagination(pagination);
      const clientPage = await ClientModel.clientList(
        parseFilter(location.search),
        pagination
      );
      setTotalCount(clientPage.page.totalElements);
      setClients(clientPage.content);
    } catch (error) {
      console.error('Failed to fetch clients:', error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return {
    clients,
    isLoading,
    totalCount,
    pagination,
    fetchClients
  };
};
